import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';
import { ANOMALY_REPORT_PATH } from './utils';

export interface IFilterServiceConfig {
  api?: string | ((params: any, data?: any) => Promise<any>);
  dataKey?: string;
  beforeRequest?: string | ((data: any) => any);
  formatData?: string | ((data: any, filterVal?: any) => any);
}

export const resolveFilterServiceParams = (
  config: IFilterServiceConfig,
  requestData: Record<string, any>,
): Record<string, any> | false => {
  let params = requestData;
  const { beforeRequest } = config;

  if (beforeRequest) {
    if (typeof beforeRequest === 'string') {
      params = stringToFunction(beforeRequest)(requestData);
    } else if (typeof beforeRequest === 'function') {
      params = beforeRequest(requestData);
    }
  }

  if (params === false) {
    return false;
  }

  return params;
};

export const resolveFilterServiceResponse = (
  config: IFilterServiceConfig,
  actualData: any,
  filterVal?: any,
): any => {
  let data = actualData;
  const { formatData } = config;

  if (formatData) {
    if (typeof formatData === 'string') {
      data = stringToFunction(formatData)(actualData, filterVal);
    } else if (typeof formatData === 'function') {
      data = formatData(actualData, filterVal);
    }
  }

  return data;
};

export const DEFAULT_ANOMALY_REPORT_API =
  '/api/v1/dashboard/anomaly_report/list';

export const DEFAULT_ANOMALY_REPORT_DATA_KEY = 'abnormalReportList';

export const LATEST_ANOMALY_REPORT_FLAG = 'latest_anomaly_report';

export const defaultAnomalyReportBeforeRequest = (data: Record<string, any>) => {
  const filterVal = data?.filterVal || {};
  const params: Record<string, any> = {
    game_code: data.gameCode,
    period: 'daily',
    format: 'html_pc',
    system: 'dashboard_pc',
    page_type: 'path',
    path: ANOMALY_REPORT_PATH,
    menu_id: data.currentMenu?.id,
    start_date: filterVal.singleDaily || '',
    end_date: filterVal.singleDaily || '',
  };

  if (filterVal.useLatestReport) {
    params.logical_flag = LATEST_ANOMALY_REPORT_FLAG;
  }

  return params;
};

export const defaultAnomalyReportFormatData = (data: unknown) =>
  Array.isArray(data) ? data : [];

export const DEFAULT_ANOMALY_REPORT_SERVICE_CONFIG: IFilterServiceConfig = {
  api: DEFAULT_ANOMALY_REPORT_API,
  dataKey: DEFAULT_ANOMALY_REPORT_DATA_KEY,
  beforeRequest: defaultAnomalyReportBeforeRequest,
  formatData: defaultAnomalyReportFormatData,
};

/** pageConfig / 入库配置可覆盖 api、beforeRequest、formatData、dataKey */
export const mergeAbnormalReportServiceConfig = (
  config?: Partial<IFilterServiceConfig>,
): IFilterServiceConfig => ({
  api: config?.api || DEFAULT_ANOMALY_REPORT_SERVICE_CONFIG.api,
  dataKey: config?.dataKey || DEFAULT_ANOMALY_REPORT_SERVICE_CONFIG.dataKey,
  beforeRequest:
    config?.beforeRequest ||
    DEFAULT_ANOMALY_REPORT_SERVICE_CONFIG.beforeRequest,
  formatData:
    config?.formatData || DEFAULT_ANOMALY_REPORT_SERVICE_CONFIG.formatData,
});
